import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TrainingPage = lazy(() => import('../pages/training/page'));
const TournamentsPage = lazy(() => import('../pages/tournaments/page'));
const ClipsPage = lazy(() => import('../pages/clips/page'));
const StreamsPage = lazy(() => import('../pages/streams/page'));
const LeaderboardPage = lazy(() => import('../pages/leaderboard/page'));
const ForumsPage = lazy(() => import('../pages/forums/page'));
const ForumTopicPage = lazy(() => import('../pages/forums/topic/page'));
const ForumCategoryPage = lazy(() => import('../pages/forums/category/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/training',
    element: <TrainingPage />,
  },
  {
    path: '/tournaments',
    element: <TournamentsPage />,
  },
  {
    path: '/clips',
    element: <ClipsPage />,
  },
  {
    path: '/streams',
    element: <StreamsPage />,
  },
  {
    path: '/leaderboard',
    element: <LeaderboardPage />,
  },
  {
    path: '/forums',
    element: <ForumsPage />,
  },
  {
    path: '/forums/category/:categorySlug',
    element: <ForumCategoryPage />,
  },
  {
    path: '/forums/topic/:topicId',
    element: <ForumTopicPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
